import {
    IBayouAuthStatusRequest, IBayouAuthStatusResponse, IBayouFormRequest, IBayouFormResponse
} from '../contracts/Bayou';
import { IZeosApiResponse } from '../contracts/ZeosApi';
import { getDataAsync, postDataAsync } from '../ZeosApiExecutor';
import { IBayou } from './interfaces/IBayou';

const API_BASE_URL = `/Bayou`;

export const Bayou: IBayou = {
  createForm: async (
    request: IBayouFormRequest
  ): Promise<IZeosApiResponse<IBayouFormResponse>> => {
    const response = await postDataAsync<IBayouFormResponse>(
      `${API_BASE_URL}/form`,
      request
    );
    return response;
  },

  getAuthStatus: async (
    request: IBayouAuthStatusRequest
  ): Promise<IZeosApiResponse<IBayouAuthStatusResponse>> => {
    const query = `?formUid=${encodeURIComponent(request.formUid)}`;
    const response = await getDataAsync<IBayouAuthStatusResponse>(
      `${API_BASE_URL}/auth-status${query}`,
      ""
    );
    return response;
  },

  processCustomer: async (
    customerId: number
  ): Promise<IZeosApiResponse<boolean>> => {
    const response = await getDataAsync<boolean>(
      `${API_BASE_URL}/process-customer/${customerId}`,
      ""
    );
    return response;
  },
};
